import c1 from './summit/sum_1.webp';
import c2 from './summit/sum_2.webp';
import c3 from './summit/sum_3.webp';
import c4 from './summit/sum_4.webp';
import c5 from './summit/sum_5.webp';
import c6 from './summit/sum_6.webp';
import c7 from './summit/sum_7.webp';
import c8 from './summit/sum_8.webp';
import c9 from './summit/sum_9.webp';
import c10 from './summit/sum_10.webp';
import c11 from './summit/sum_11.webp';
import c12 from './summit/sum_12.webp';
import c13 from './summit/sum_13.webp';
import c14 from './summit/sum_14.webp';
import c15 from './summit/sum_15.webp';
import c16 from './summit/sum_16.webp';
import c17 from './summit/sum_17.webp';
import c18 from './summit/sum_18.webp';
import c19 from './summit/sum_19.webp';
import c20 from './summit/sum_20.webp';

const summitImg = [
	c1,
	c2,
	c3,
	c4,
	c5,
	c6,
	c7,
	c8,
	c9,
	c10,
	c11,
	c12,
	c13,
	c14,
	c15,
	c16,
	c17,
	c18,
	c19,
	c20,
];

export default summitImg;
